import { request } from '../request'
import { User } from '../types'

export class UserService {

  getUser(): Promise<User> {
    return request.get('/api/user.json')
  }

  agreeToTos(): Promise<any> {
    return request.put('/api/user/agree_to_tos.json')
  }

}
